export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '0c17d6ba-feb8-4006-8b07-16e6589b27cf';
export const MODAL_CLOSE_SEC = 2.5;
